import { Router } from 'express';
import { AgentService } from '../services/agent-service.js';
import { ApiError } from '../types.js';

export const agentRouter = Router();
const agentService = new AgentService();

// 获取所有 Agent
agentRouter.get('/', async (req, res, next) => {
  try {
    const agents = await agentService.list();
    res.success(agents);
  } catch (error) {
    next(error);
  }
});

// 获取单个 Agent
agentRouter.get('/:id', async (req, res, next) => {
  try {
    const agent = await agentService.get(req.params.id);
    if (!agent) {
      throw new ApiError(404, 'Agent not found');
    }
    res.success(agent);
  } catch (error) {
    next(error);
  }
});

// 创建 Agent
agentRouter.post('/', async (req, res, next) => {
  try {
    const { name, role, description, status, category, capabilities, tools, prompts } = req.body;
    
    if (!name || !role || !description) {
      throw new ApiError(400, 'Name, role and description are required');
    }

    const agent = await agentService.create({
      name,
      role,
      description,
      avatar: req.body.avatar,
      status: status || 'active',
      category: category || 'development',
      capabilities: capabilities || [],
      tools: tools || [],
      prompts: prompts || {},
      preferences: req.body.preferences,
      collaboration: req.body.collaboration,
      tags: req.body.tags || [],
      version: req.body.version || '1.0.0'
    });
    
    res.created(agent);
  } catch (error) {
    if (error instanceof Error && error.message === 'Agent 名称已存在') {
      next(new ApiError(409, error.message));
    } else {
      next(error);
    }
  }
});

// 更新 Agent
agentRouter.put('/:id', async (req, res, next) => {
  try {
    const updates = req.body;
    const agent = await agentService.update(req.params.id, updates);
    res.success(agent);
  } catch (error) {
    if (error instanceof Error) {
      if (error.message === 'Agent 不存在') {
        next(new ApiError(404, error.message));
      } else if (error.message === 'Agent 名称已存在') {
        next(new ApiError(409, error.message));
      } else {
        next(error);
      }
    } else {
      next(error);
    }
  }
});

// 删除 Agent
agentRouter.delete('/:id', async (req, res, next) => {
  try {
    await agentService.delete(req.params.id);
    res.deleted();
  } catch (error) {
    if (error instanceof Error && error.message === 'Agent 不存在') {
      next(new ApiError(404, error.message));
    } else {
      next(error);
    }
  }
});

// 更新 Agent 指标
agentRouter.patch('/:id/metrics', async (req, res, next) => {
  try {
    const { tasksCompleted, successRate, averageTime } = req.body;
    await agentService.updateMetrics(req.params.id, {
      tasksCompleted,
      successRate,
      averageTime
    });
    res.success({ message: 'Metrics updated' });
  } catch (error) {
    next(error);
  }
});